export interface UserProgram {
    id: string;
    user_id: string;
    program_id: string;
    program_name: string;
    enrollment_date: Date;
    completion_date?: Date;
    progress_percentage: number;
    status: ProgramStatus;
    certificates_earned: string[];
    current_module?: string;
    total_modules?: number;
    completed_modules?: number;
    time_spent?: number; // in minutes
    last_accessed?: Date;
    created_on: Date;
    last_modified_on: Date;
    is_deleted: boolean;
}

export enum ProgramStatus {
    ENROLLED = 'ENROLLED',
    IN_PROGRESS = 'IN_PROGRESS',
    COMPLETED = 'COMPLETED',
    DROPPED = 'DROPPED',
    PAUSED = 'PAUSED',
    CERTIFIED = 'CERTIFIED'
}

export interface CreateUserProgramRequest {
    user_id: string;
    program_id: string;
    program_name: string;
}

export interface UpdateUserProgramRequest {
    progress_percentage?: number;
    status?: ProgramStatus;
    current_module?: string;
    completed_modules?: number;
    time_spent?: number;
    last_accessed?: Date;
    completion_date?: Date;
}

export interface UserProgramListResponse {
    data: {
        items: UserProgram[];
        total: number;
        page: number;
        limit: number;
    };
    success: boolean;
    message?: string;
}

export interface ProgramProgress {
    user_id: string;
    program_id: string;
    current_module: string;
    progress_percentage: number;
    completed_modules: number;
    total_modules: number;
    estimated_completion?: Date;
}
